let config = {
    cloudImgUrl: 'https://portfolium1.cloudimg.io/s/crop/{{width}}x{{height}}',
};

export default config;
